/**
 * Typ eines Datenendkanals – Spiegel von `DEType` aus APISharedLib
 * (AVS_Web-API). Reihenfolge und Werte müssen mit der API übereinstimmen.
 */
export enum DataEndChannelType {
  Unknown = 0,
  LED = 1,
  PW = 2,
  BLINKER = 3,
  RADAR = 4,
  CLUSTER = 5,
  FUELCELL = 6,
  DIGITALINPUT = 7,
  DIGITALOUTPUT = 8,
  RADARPOWERSWITCH = 9,
  LEDPOWERSWITCH = 10,
  ROUTER = 11,
  SOLAR = 12,
  EVAVOLTAGE = 13,
  BLINKER_CLUSTER = 14,
  PW_CLUSTER = 15,
  BRIGHTNESS100 = 16,
  ONLINE_LED = 17,
  LPCAM = 18,
  PTZCAM = 19,
  LANESWITCH = 20,
  BAR = 21,
  SWING = 22,
  WEATHER = 23,
}

/** Manuelle Steuerung eines Datenendkanals (API: `ManualControl`). */
export interface ManualControl {
  id: number;
  /** JSON mit den Teil-Steuerungen AQ, MQ, DO, DI, Barrier (PascalCase, wie von der API serialisiert). */
  settings: string;
  createdAt: string;
  lastChangedAt: string;
  lastChangedByUserId: number;
}

/** AQ-Teil der ManualControl-Settings, so wie die API ihn serialisiert. */
export interface ParsedAqControl {
  Active?: boolean;
  Code?: number;
  Function?: number;
  Time?: number;
  HighPriority?: boolean;
}

/**
 * Request-Body für `POST DataEndChannel/{id}/setaqmanualcontrol` (API: `AQConfig`).
 * `function`: 0 = Aus, 1 = An, 2 = Blinkend (wie im AVS_Portal).
 */
export interface SetAqControl {
  active: boolean;
  code: number;
  function: number;
  time: number;
}

export const AQ_FUNCTION_OFF = 0;
export const AQ_FUNCTION_ON = 1;

/** Liest den AQ-Teil aus den ManualControl-Settings; `null`, wenn nicht vorhanden oder nicht lesbar. */
export function parseAqControl(
  manualControl: ManualControl | null | undefined,
): ParsedAqControl | null {
  if (!manualControl?.settings) return null;
  try {
    const parsed: unknown = JSON.parse(manualControl.settings);
    if (typeof parsed !== 'object' || parsed === null) return null;
    const aq = (parsed as { AQ?: ParsedAqControl | null }).AQ;
    return aq ?? null;
  } catch {
    return null;
  }
}

/** True, wenn für den Kanal eine aktive manuelle AQ-Steuerung hinterlegt ist. */
export function isAqControlActive(manualControl: ManualControl | null | undefined): boolean {
  return parseAqControl(manualControl)?.Active === true;
}
